module.exports = "/_next/static/images/logo_plus-4886936446ce77da48cb567834768c1b.png";